import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";
import Images from "../../utils/Images";

const fallbackIllustration =
  "https://images.unsplash.com/photo-1611162618071-b39a2ec1deb1?q=80&w=800&auto=format&fit=crop&ixlib=rb-4.0.3";

function ContactCard({ icon: Icon, title, subtitle, href, delay = 0 }) {
  return (
    <motion.a
      href={href}
      target={href?.startsWith("http") ? "_blank" : undefined}
      rel={href?.startsWith("http") ? "noreferrer" : undefined}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5, delay }}
      className="flex gap-3 items-center p-4 rounded-xl border transition-colors bg-emerald-100/50 border-emerald-300/30 hover:bg-emerald-100/70"
    >
      <div className="flex justify-center items-center w-10 h-10 text-white bg-emerald-500 rounded-full">
        <Icon size={18} />
      </div>
      <div className="leading-tight">
        <div className="text-sm font-semibold text-emerald-800">{title}</div>
        <div className="text-xs text-emerald-900/80">{subtitle}</div>
      </div>
    </motion.a>
  );
}

export default function ContactCTA() {
  return (
    <section className="relative py-12">
      <div className="px-6 mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="overflow-hidden relative bg-emerald-50 rounded-2xl border-2 border-emerald-600/30"
        >
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full blur-3xl bg-emerald-300/20" />
            <div className="absolute -right-24 -bottom-24 w-72 h-72 rounded-full blur-3xl bg-emerald-200/20" />
          </div>

          <div className="relative px-6 py-10 mx-auto max-w-3xl text-center md:py-12">
            <div className="flex justify-center">
              <img
                src={Images.contact_cta || fallbackIllustration}
                alt="Contact illustration"
                className="object-contain w-16 h-16 rounded-xl shadow-sm"
              />
            </div>
            <h3 className="mt-4 text-2xl font-extrabold text-gray-900 md:text-3xl">
              Have questions for us?
            </h3>
            <p className="mt-2 text-sm text-gray-600 md:text-base">
              Reach out to us through any of these channels. We're here to help
              you with all your issues{" "}
            </p>

            <div className="grid grid-cols-1 gap-4 mt-6 sm:grid-cols-2">
              <ContactCard
                icon={Mail}
                title="General Queries"
                subtitle="info@tripsecuregh.com"
                href="mailto:info@tripsecuregh.com"
                delay={0.05}
              />
              <ContactCard
                icon={Phone}
                title="Customer Support"
                subtitle="+233 (0)20 401 4370"
                href="tel:+233204014370"
                delay={0.1}
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
